module.exports = "/images/vendor/flag-icon-css/flags/1x1/ss.svg?e3933b4455dc06b90bba00e59fba0f59";